import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'

import styles from './Switch.module.scss'

const Switch = forwardRef((props, ref) => {
  const { checked, onChange, ...rest } = props
  const [internalChecked, setInternalChecked] = useState(false)

  const isChecked = checked === 'undefined' ? internalChecked : checked

  const handleChange = (e) => {
    if (typeof checked !== 'undefined' && onChange) {
      onChange(e)
      return
    }

    setInternalChecked(!isChecked)
  }

  return (
    <label className={styles.Switch}>
      <input ref={ref} type='checkbox' {...rest} className={styles.Input} checked={isChecked} onChange={handleChange} />
      <div className={styles.Slider} />
    </label>
  )
})

Switch.propTypes = {
  /**
   * Switch value, determines whether toggle/switch is on or off
   */
  checked: PropTypes.bool,
  /**
   * Optional change handler
   */
  onChange: PropTypes.func
}

Switch.defaultProps = {
  checked: undefined,
  onChange: undefined
}

export default Switch
